import './Categories.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import Picture from '@/common/components/atoms/Picture/Picture';
import { ROUTE_NODES } from '@/common/constants';
import { useNodesTreeContext } from '@/common/contexts/NodesTreeContext/NodesTreeContext';

import {
  CategoriesDefaultProps,
  CategoriesPropTypes,
} from './Categories.proptypes';

const Categories = ({ className }) => {
  const { t } = useTranslation();

  const { nodesTree, isSuccess } = useNodesTreeContext();

  const capitalizeFirstLetter = (input) => {
    if (!input) return '';
    const lowercased = input.toLowerCase();
    return lowercased.charAt(0).toUpperCase() + lowercased.slice(1);
  };

  if (isSuccess) {
    return (
      <div className={cn('home-categories', className)}>
        <div className="wrapper">
          <div className="title">
            <h2 className="h2">{t('ebat:entities:home.categories.title')}</h2>
          </div>
          <div className="home-categories__content">
            {nodesTree &&
              nodesTree.map((node, index) => (
                <NavLink
                  className="category__card"
                  to={`${ROUTE_NODES}/${node.path}`}
                  key={index}
                >
                  <Picture
                    alt={node.image?.alt ?? ''}
                    className="category__image"
                    src={node.image?.url ?? ''}
                  />
                  <span className="category__title">
                    {capitalizeFirstLetter(node.name)}
                  </span>
                </NavLink>
              ))}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

Categories.defaultProps = {
  ...CategoriesDefaultProps,
};

Categories.propTypes = {
  ...CategoriesPropTypes,
};

export default Categories;
